import { Col, Row } from "antd";
import { ReactNode } from "react";

const SimplePage = (props: { children: ReactNode, extraHeaderCols?: React.ReactNode }) => {
    return (
        <>
            <div style={{ width: '100%', height: 90, background: 'rgb(205 215 245)', marginTop: 10, paddingTop: 10, direction: 'rtl' }}>
                <Row className="col-xl-12 col-lg-12 col-sm-12" style={{ padding: 0, margin: 0 }}>
                    <Col span={14}>
                        <Row style={{ margin: 0 }}>
                            <div className="login-logo" style={{ backgroundImage: "url(/logo.png)", backgroundSize: 'contain' }}></div>
                            <div className="login-title" style={{ marginRight: 20 }}>
                                <span className="logo-title">شرکت خدمات تجهیزات الکترونیک زبده</span>
                                <span className="line"></span>
                                <span className="logo-subtitle"> پورتال خسارت و تعمیرات تجهیزات الکترونیک </span>
                            </div>
                        </Row>
                    </Col>
                    {props.extraHeaderCols}
                </Row>
            </div>
            <div className="login-scroll" style={{ width: "100%", display: 'flex', textAlign: "center", justifyContent: "center", marginTop: 20 }}>
                <div className="col-xl-3 col-xl-4 col-lg-5 col-md-8 col-sm-10 col-xs-10" style={{ margin: 10 }}>
                    {props.children}
                </div>
            </div>
        </>
    );
};

export default SimplePage;